import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { CustomerService } from '../../../services/customer.service';
import { AccountService } from '../../../services/account.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AccountGroup, gridPageRequest } from '../../../model/common/common.model';

@Component({
  selector: 'app-create-quick-account-SubGrouptype-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-quick-account-SubGrouptype-lookup.component.html',
  styleUrl: './create-quick-account-SubGrouptype-lookup.component.scss'
})
export class AccountSubGrouptypeLookupComponent implements OnInit {
  @Output() AccountSubGroupId = new EventEmitter<any>();
  constructor(  private ref: DynamicDialogRef,private messageService: MessageService, private accountServices: AccountService, private customerService: CustomerService) { }

  submitted: boolean = false;
  loader: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  filterAG: AccountGroup[] = [];
  AGDropdown: AccountGroup[] = [];
  accountTypeForm = new FormGroup({
    AccountSubGroupCode: new FormControl('', Validators.required),
    // AccountTypeName: new FormControl(),
    manualEntry: new FormControl(true),
    AccountSubGroupDescription: new FormControl(),
    AccountSubGroupName: new FormControl('', Validators.required),
    isActive: new FormControl(true),
    createdBy: new FormControl(''),
    upatedBy: new FormControl(''),
    accountGroupId: new FormControl(),
    accountGroupCode: new FormControl('', Validators.required),
  });
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 1000,
    id: 0
  }

  ngOnInit(): void {
    this.getAG();
  }

  get formControls() {
    return this.accountTypeForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.accountTypeForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  checkAccountTypeCode() {
    if (!this.accountTypeForm.controls.AccountSubGroupCode.value) {
      return;
    }

    this.accountServices.checkAccountSubGroupCode(this.accountTypeForm.controls.AccountSubGroupCode.value).subscribe(
      (data: any) => {
        if (data.success == true) {
          // console.log(data);
        } else {
          this.accountTypeForm.controls.AccountSubGroupCode.setValue('');
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.accountTypeForm.controls.manualEntry.setValue(true);
        }
      },
      (error: any) => {
        console.log(error);
      });

  }

  manualEntry() {
    const manualEntryValue = this.accountTypeForm.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.accountTypeForm.controls.AccountSubGroupCode.setValue('');
    } else {
      this.getAccountTypeCode();
    }
  }

  getAccountTypeCode() {
    this.loader = true;
    this.accountServices.autogenerateAccountSubGroupCode().subscribe({
      next: (data: any) => {
        const alphanumericCode = '';
        const AccountSubGroupCode = alphanumericCode + data;
        this.accountTypeForm.controls.AccountSubGroupCode.setValue(AccountSubGroupCode);
        this.loader = false;
      },
      error: (error: any) => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }


  createAccountGroup(): void {
    this.submitted = true;

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    const formData = this.accountTypeForm.value;
    //   if (!formData.AccountType) {
    //   formData.AccountType = '123';  
    // } else if (Array.isArray(formData.AccountType)) {
    //   formData.AccountType = formData.AccountType[0];  
    // }

    // if (typeof formData.isActive === 'string') {
    //   formData.isActive = formData.isActive === 'true'; 
    // }

    const username = localStorage.getItem('username');
    if (username) {
      formData.createdBy = username;
      formData.upatedBy = username;
    } else {
      console.error('Username not found in localStorage');
      return; 
    }
  
    this.loader = true;
  
    console.log('Submitting formData:', formData); 
    this.accountServices.createAccountSubGroup(formData).subscribe({
      next: (data: any) => {
        if (data && typeof data === 'number') {
          console.log('Created Account Sub Group ID:', data);
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Account Sub Group created successfully`
          });

          this.AccountSubGroupId.emit(data);
          this.ref.close(data);
        } else {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: 'Failed to create the Account Sub Group.'
          });
        }
      },
      error: (error: any) => {
        console.error('Error creating Sub Group:', error);
        this.loader = false;
  
        // Log the error and provide a detailed message to the user
        if (error.error) {
          console.error('API error details:', error.error); // Log API error response
        }
  
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while creating the Sub Group'
        });
      }
    });
  }
  
  
  setAccountGroup(event: any) {
    if (event && event.value) {
      const accountGroup = Array.isArray(event.value) ? event.value[0] : event.value;
      console.log('Account Group:', accountGroup);
            console.log('Form Controls:', this.accountTypeForm.controls);
      
      // Check if form controls exist and are not disabled
      if (this.accountTypeForm.controls.accountGroupId && this.accountTypeForm.controls.accountGroupCode) {
        this.accountTypeForm.patchValue({
          accountGroupId: accountGroup.accountGroupId,
          accountGroupCode: accountGroup.accountGroupCode,
          // accountGroupDescription: accountGroup.accountGroupDescription, 
          // accountGroupName: accountGroup.accountGroupName  
        });
        console.log('Form Patched:', this.accountTypeForm.value);
      } else {
        console.error('Form controls not found!');
      }
    } else {
      console.error('No event value received!');
    }
  }
  filterAGs(event: any) {
    let filtered: any[] = [];
    let query = event.query;
  
    for (let i = 0; i < this.AGDropdown.length; i++) {
      let group = this.AGDropdown[i];
      if (group.accountGroupName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(group);
      }
    }
    this.filterAG = filtered;
  }
  getAG(){
    this.accountServices.getAllAccountGroups(this.pageRequest).subscribe({
      next: (data:any) => {
        this.AGDropdown = data.accountGroup;
      },
      error: error => {
        console.log(error);
      }
    });
  }
  
}  